export const hasNonBlankValues = (obj) => {
    return Object.keys(obj).filter(key => {
        const value = obj[key];
        return value !== '' && (!Array.isArray(value) || value.length > 0);
    }).length > 0 ? true : false;
};